enum SHIPPING_METHODS {
  NONE = undefined,
  NAMED_DAY = 22,
  STANDARD = 11,
  SECOND_DAY = 12,
  SECOND_DAY_PM = 23,
  OVERNIGHT = 13,
  STANDARD2 = 14,
  OVERNIGHT2 = 15,
  SATURDAY = 17,
  POST_EXPRESS = 21,
  ELECTRONIC_SHIPPING = 99,
  BOPIS = 101,
  COURIER = 102,
  LOCAL_COLLECTION = 24,
  STORE_COLLECTION = 25,
  SELF_COLLECTION = 26,
  STANDARD_UPS = 1,
  COLISSIMO = 2,
  EXPRESS_CHRONOPOST = 3,
}

export default SHIPPING_METHODS;
